import React from "react";

const InputForm = ({ name, autoComplete, maxLength, placeholder, value, onChange }) => (
  <input
    name={name}
    autoComplete={autoComplete}
    className="pageFormSubInput fontBook colorBlack"
    type="text"
    maxLength={maxLength}
    placeholder={placeholder}
    value={value}
    onChange={(e) => onChange(e.target.value, name)}
  />
);

export default InputForm;



// WEBPACK FOOTER //
// ./src/containers/components/InputForm.js